import type { ReactNode } from "react";
import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

export const GuidePreview = ({
  id,
  label = "App preview",
  caption,
  onReset,
  children,
}: {
  id: string;
  label?: string;
  caption: string;
  onReset?: () => void;
  children: ReactNode;
}) => (
  <figure
    id={id}
    aria-label={label}
    className="not-typeset my-6 min-w-0 text-ink"
  >
    <Text render={<figcaption />} tone="muted" className="mb-3 leading-relaxed">
      {caption}
    </Text>
    <Stack
      gap={0}
      align="stretch"
      className="min-w-0 overflow-hidden rounded-md border border-line bg-surface-raised"
    >
      {children}
    </Stack>
    <Stack
      direction="row"
      gap={2}
      align="center"
      justify="between"
      className="mt-2"
    >
      <Text variant="caption" tone="muted">
        {onReset
          ? "Sample data. Changes stay here."
          : "Example only. These controls are not active."}
      </Text>
      {onReset && (
        <Button
          variant="ghost"
          size="xs"
          onClick={onReset}
          aria-label="Reset example"
        >
          Reset
        </Button>
      )}
    </Stack>
  </figure>
);
